// Wichita Falls Equipment — Shopify Theme JS
(function () {

  // ---- Mobile nav toggle ----
  const burger = document.getElementById('nav-toggle');
  const navLinks = document.getElementById('nav-links');
  if (burger && navLinks) {
    burger.addEventListener('click', function () {
      const open = navLinks.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
    });
  }

  // ---- Nav dropdown (touch support) ----
  function closeMenus() {
    document.querySelectorAll('.nav-group.open').forEach(function (g) {
      g.classList.remove('open');
      const t = g.querySelector('.nav-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  document.querySelectorAll('.nav-group > .nav-trigger').forEach(function (trigger) {
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      const group = trigger.closest('.nav-group');
      const open = !group.classList.contains('open');
      closeMenus();
      group.classList.toggle('open', open);
      trigger.setAttribute('aria-expanded', String(open));
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-group')) closeMenus();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenus();
      if (navLinks) navLinks.classList.remove('open');
    }
  });

  // ---- Footer year ----
  const yr = document.getElementById('year');
  if (yr) yr.textContent = new Date().getFullYear();

  // ---- Floating chat widget ----
  if (!document.getElementById('chat-widget') && !document.body.classList.contains('no-chat')) {
    const FB_ID = document.body.dataset.facebookId || '61593174506715';
    const widget = document.createElement('div');
    widget.id = 'chat-widget';
    widget.innerHTML = `
      <div id="chat-panel" role="dialog" aria-label="Contact us">
        <div class="chat-head">
          <strong>Questions? Message us.</strong>
          <span>We usually reply within the hour.</span>
        </div>
        <div class="chat-body">
          <a class="chat-opt" href="https://m.me/${FB_ID}" target="_blank" rel="noopener">
            <svg viewBox="0 0 24 24" fill="#0084ff"><path d="M12 2C6.36 2 2 6.13 2 11.7c0 3.19 1.42 6.02 3.65 7.88V24l3.34-1.83c.89.25 1.84.38 2.83.38 5.64 0 10-4.13 10-9.7S17.64 2 12 2zm1 12.06l-2.55-2.72-4.97 2.72 5.47-5.81 2.61 2.72 4.9-2.72-5.46 5.81z"/></svg>
            <span>Facebook Messenger<small>Chat with us on Facebook</small></span>
          </a>
          <a class="chat-opt" id="chat-phone" href="#">
            <svg viewBox="0 0 24 24" fill="none" stroke="#39ff14" stroke-width="2"><path d="M22 16.9v3a2 2 0 01-2.2 2A19.8 19.8 0 012 4.2 2 2 0 014 2h3a2 2 0 012 1.7c.1 1 .4 2 .7 2.9a2 2 0 01-.5 2.1L8 10a16 16 0 006 6l1.3-1.2a2 2 0 012.1-.5c.9.3 1.9.6 2.9.7a2 2 0 011.7 2z"/></svg>
            <span>Call Us<small id="chat-phone-num"></small></span>
          </a>
          <a class="chat-opt" href="/pages/contact">
            <svg viewBox="0 0 24 24" fill="none" stroke="#39ff14" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M22 7l-10 6L2 7"/></svg>
            <span>Send a Message<small>Request a quote or appointment</small></span>
          </a>
        </div>
        <div class="chat-foot">Sales by appointment &middot; Wichita Falls, TX</div>
      </div>
      <button id="chat-launcher" type="button" aria-label="Open chat" aria-expanded="false">
        <svg class="icon-open" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 01-9 8.4 9.9 9.9 0 01-3.8-.7L3 21l1.9-4.9A8.4 8.4 0 013 11.5a8.4 8.4 0 018.5-8.4h.5a8.4 8.4 0 019 8.4z"/></svg>
        <svg class="icon-close" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
      </button>`;
    document.body.appendChild(widget);

    // Wire up phone link and number from meta tag or data attr
    const phoneMeta = document.querySelector('meta[name="shop-phone"]');
    const phone = (phoneMeta && phoneMeta.content) || '(940) 400-0305';
    const phoneRaw = phone.replace(/[^0-9]/g, '');
    const phoneLink = document.getElementById('chat-phone');
    const phoneNum  = document.getElementById('chat-phone-num');
    if (phoneLink) phoneLink.href = 'tel:+1' + phoneRaw;
    if (phoneNum)  phoneNum.textContent = phone;

    const launcher = document.getElementById('chat-launcher');
    if (localStorage.getItem('wfe_chat_seen')) widget.classList.add('seen');

    function setChatOpen(open) {
      widget.classList.toggle('open', open);
      document.body.classList.toggle('chat-open', open);
      launcher.setAttribute('aria-expanded', String(open));
      launcher.setAttribute('aria-label', open ? 'Close chat' : 'Open chat');
      if (open) {
        widget.classList.add('seen');
        localStorage.setItem('wfe_chat_seen', '1');
      }
    }

    launcher.addEventListener('click', function () {
      setChatOpen(!widget.classList.contains('open'));
    });
    document.addEventListener('click', function (e) {
      if (!widget.contains(e.target) && widget.classList.contains('open')) {
        setChatOpen(false);
      }
    });
  }

})();
